<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <mat-card-title-group class="home-card" id="title">
        <mat-card-title>{{"PERM.HEADER" | translate }}</mat-card-title>
    </mat-card-title-group>

    <mat-card-content>
        <div class="home-card" id="content">
            <div>
                <ng-container *ngIf="this.roleHandling.isRole('Sennebogen')">
                    <h3>{{"PERM.TEXT" | translate }}</h3>
                </ng-container>
                <ng-container *ngIf="!this.roleHandling.isRole('Sennebogen')">
                    <h3>{{"PERM.EXTERN" | translate }}</h3>
                </ng-container>
            </div>
            <div class="btn_connect">
                <button mat-raised-button color="primary" (click)="logout()">{{"PERM.BTN" | translate }}</button>
            </div> 
        </div>
    </mat-card-content>
</mat-card>